<!-- 查询控件 -->
<template>
  <el-upload
    :on-success="onSuccess"
    :on-progress="onProgress"
    :show-file-list="false"
    :accept="accept"
    :data="{ bucket: 'zkfs' }"
    :action="aidaApiUrl + '/oss/endpoint/object/bucket/create'"
  >
    <el-button
      size="small"
      :loading="loading"
      icon="el-icon-upload"
      type="primary"
      >点击上传
    </el-button>
  </el-upload>
</template>

<script>
import { aidaApiUrl } from "@/config";

export default {
  name: "iconConfig",
  data() {
    return {
      aidaApiUrl: aidaApiUrl,
      loading: false,
    };
  },
  props: {
    accept: {
      default: "*",
    },
    modelValue: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {},
  components: {},
  mounted() {},
  methods: {
    onProgress() {
      this.loading = true;
    },
    onSuccess(res) {
      const { id } = res.data;
      this.loading = false;
      const resourceUrl = `/api/oss/endpoint/object/view/${id}`;
      this.$emit("update:modelValue", resourceUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.config-box {
  padding: 5px 0;
}
</style>
